/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Bhargavi       2/12/2020     3625:Done Changes related to Localize month name
*********************************************************************************/
import i18n from "../../../i18n";

const lang = i18n.language;
function getmonthName(month) {
  var monthLang = [];
  var engMonth=[
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]

  switch (lang) {
    case "en":
      monthLang = engMonth;
      break;
    case "en-US":
      monthLang = engMonth;
      break;
    case "de":
      monthLang = [
        "Januar",
        "Februar",
        "März",
        "April",
        "Kann",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ];
      break;
    case "fr":
      monthLang = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];
      break;
    case "es":
      monthLang = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      break;
    default:
        monthLang = engMonth;
  }
  return monthLang[month];
}

export default getmonthName;
